"use client";

import { useEffect, useState } from "react";
import SpinningWheel from "@/components/SpinningWheel";
import { MatchSpinEvent } from "@/lib/multiplayer";

// Replays the opponent's wheel for a spectating (finished) player. Each new
// spin event arrives the instant the opponent's wheel starts turning, so this
// animates in near-sync and lands on the same result.
export default function SpectatorWheel({
  spin,
}: {
  spin: MatchSpinEvent | null;
}) {
  const [spinToken, setSpinToken] = useState(0);
  const [showResult, setShowResult] = useState(false);

  // A new seq means a fresh spin to animate.
  useEffect(() => {
    if (!spin) return;
    setShowResult(false);
    setSpinToken((t) => t + 1);
    // Only a new seq should retrigger an animation, not every prop identity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spin?.seq]);

  if (!spin) {
    return (
      <div className="flex aspect-square w-[min(60vw,30vh,12rem)] items-center justify-center rounded-full border-4 border-[#1a1a22] bg-white/5 text-center text-xs text-white/40">
        Waiting for their next spin…
      </div>
    );
  }

  const wheel = {
    id: "spectate",
    name: spin.wheelName,
    options: spin.options,
  };
  const resultOption = wheel.options[spin.resultIndex] ?? null;

  return (
    <SpinningWheel
      wheel={wheel}
      spinToken={spinToken}
      resultOption={resultOption}
      onSpinEnd={() => setShowResult(true)}
      onTick={() => {}}
      showResult={showResult}
      showValue={spin.showValue}
      discClassName="w-[min(60vw,30vh,12rem)]"
    />
  );
}
